@if (this.mobileDetection) {
  @if (this.container() === 'button') {
    <cam-button [options]="{ circular: true }" (action)="this.openDialog()">
      <cam-font-icon name="search" type="lg"></cam-font-icon>
    </cam-button>
  }
  @if (this.container() === 'link') {
    <div (click)="this.openDialog()">
      <cam-font-icon name="search" type="lg"></cam-font-icon>
    </div>
  }
}

@if (!this.mobileDetection) {
  <ng-template
    [ngTemplateOutlet]="searchTemplate"
    [ngTemplateOutletContext]="{ options: { isDropDown: true } }"
  ></ng-template>
}

<ng-template #searchTemplate let-options="options">
  <cam-search-history-displayer
    [placeholder]="this.placeholder()"
    [searchHistory]="this.searchHistory()"
    [isDropDown]="options.isDropDown"
    (valueCompleted)="this.action($event)"
  ></cam-search-history-displayer>
</ng-template>
